import {PropsWithChildren} from 'react';

import {classNames} from '../../util/css';

import * as styles from './chart-tooltip.scss';

type PropsType = PropsWithChildren<Record<string, unknown>> & {
    className?: string;
    position?: 'left' | 'right' | 'top';
};

export function ChartTooltip(props: PropsType): JSX.Element {
    const {children, className, position = 'top'} = props;

    return (
        <div
            className={classNames(
                styles.ChartTooltip_container,
                {
                    [styles.ChartTooltip_container__top]: position === 'top',
                    [styles.ChartTooltip_container__left]: position === 'left',
                    [styles.ChartTooltip_container__right]: position === 'right',
                },
                className
            )}
        >
            {children}
        </div>
    );
}
